import React from 'react';
import { HeadlineLarge } from "../../../atoms/fonts/Headline";
import { BodyLarge } from "../../../atoms/fonts/Body";
import { LinkButton } from "../../../atoms/buttons/LinkButton";
import { PrimaryButton } from "../../../atoms/buttons/PrimaryButton";
import { Trans, useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectIsInTeams } from '@shared/store/auth.duck';
import { ButtonSize } from '@shared/ui/atoms/buttons/ButtonStyling';

interface Props {
  onDone: () => any;
  hideImages: boolean;
}

export function AddTeamMemberLimitReached(props: Props) {
  const {t} = useTranslation();
  const isInTeams = useSelector(selectIsInTeams);

  return (
    <React.Fragment>
      <HeadlineLarge style={{marginBottom: 12}}>{t('settings.member-limit-reached')}</HeadlineLarge>

      {isInTeams ? <>
        <BodyLarge style={{marginBottom: 24}}>{t('settings.account-full-in-teams')}</BodyLarge>
      </> : <>
        <BodyLarge style={{marginBottom: 24}}><Trans i18nKey={'settings.account-full-normal'} /></BodyLarge>

        <div style={{marginBottom: 16}}>
          <LinkButton dataTest="upgradeButton" size={ButtonSize.Large} text="button.upgrade-my-account"
                      link="/manage/payments"
                      type="outline" onClick={props.onDone} fullWidth={true}/>
        </div>
      </>}

      <PrimaryButton dataTest="doneButton" size={ButtonSize.Large} text="button.done-for-now" click={props.onDone}
                     fullWidth={true}/>

    </React.Fragment>
  )
}
